import { render, staticRenderFns } from "./TeacherService.vue?vue&type=template&id=83d2ee58&"
import script from "./TeacherService.vue?vue&type=script&lang=js&"
export * from "./TeacherService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports